module.exports = __webpack_public_path__ + "img/img-login.2620a345.svg";